module.exports = __webpack_public_path__ + "static/media/iced_armor.d074bed6.png";